import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { SuccessToast, ErrorToast } from "../../../components/toast/Toasts";
import { ITravelActivity } from "../travelActivityModel";

export const getAllTravelActivity = createAsyncThunk(
  "TravelActivity/FindAllTravelActivity",
  async (formData: { Name: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelActivity/FindAllTravelActivity`,
        formData
      );
      return response.data?.Data as ITravelActivity[];
    } catch (error: any) {
      console.error("Error Fetching Travel Activities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveTravelActivity = createAsyncThunk(
  "TravelActivity/FindAllActiveTravelActivity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/TravelActivity/FindAllActiveTravelActivity`
      );
      return response.data?.Data as ITravelActivity[];
    } catch (error: any) {
      console.error("Error Fetching Active Travel Activities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createTravelActivity = createAsyncThunk(
  "TravelActivity/InsertTravelActivity",
  async (travelActivityData: ITravelActivity) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelActivity/InsertTravelActivity`,
        travelActivityData
      );
      SuccessToast(response.data?.Details || "Travel Activity created successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Travel Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTravelActivity = createAsyncThunk(
  "TravelActivity/UpdateTravelActivity",
  async (travelActivityData: ITravelActivity) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelActivity/UpdateTravelActivity`,
        travelActivityData
      );
      SuccessToast(response.data?.Details || "Travel Activity updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Travel Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteTravelActivity = createAsyncThunk(
  "TravelActivity/DeleteTravelActivity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelActivity/DeleteTravelActivity`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Travel Activity deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Travel Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getTravelActivityByID = createAsyncThunk(
  "TravelActivity/FindByIDTravelActivity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelActivity/FindByIDTravelActivity`,
        { ID }
      );
      return response.data?.Data as ITravelActivity;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Travel Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const activeInactiveTravelActivity = createAsyncThunk(
  "TravelActivity/ActiveInActiveTravelActivity",
  async (formData: { ID: number; IsActive: boolean }) => {
    try {
      // The user used FindAllActiveTravelActivity with this payload in their snippet?
      // "https://localhost:7130/api/TravelActivity/FindAllActiveTravelActivity { \"ID\": 2, \"IsActive\": true }"
      // But commonly it's ActiveInActive. I'll follow common pattern unless they insisted.
      // Actually, let's use the exact URL they provided if it seemed to be for that.
      // But ServiceLocation has /ActiveInActiveServiceLocation.
      // I'll take a safe bet and use a possible typo-fix if needed, or follow their provided URL.
      // Actually, let's use the provided URL for "ActiveInActive" logic if they labeled it as such.
      const response = await axiosApiInstance.post(
        `${API_URL}/TravelActivity/ActiveInActiveTravelActivity`,
        formData
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Travel Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
